import faker from 'faker/locale/en';
import type { WorksiteFilter, WorksiteWithAccountsCount } from 'api/modules/worksites/api';
import { fakeTimezone, randomIn } from '../../_utils';
export const fakeWorksiteFilter = (base: Partial<WorksiteFilter> = {}): WorksiteFilter => ({
  id: base.id || faker.datatype.uuid(),
  name: base.name || `${faker.address.city()} ${faker.company.companySuffix()}`
});

/**
 * Generate many fake worksite filters for testing infinite scroll
 * @param count Number of worksites to generate
 */
export const generateManyWorksiteFilters = (count: number): WorksiteFilter[] => Array.from({
  length: count
}, (_, i) => fakeWorksiteFilter({
  name: `Worksite ${i + 1} - ${faker.address.city()}`
}));

/**
 * Generate a fake worksite with optional accountsCount and buildingsCount
 * @param base - Partial worksite properties to override defaults
 */
export const fakeWorksite = (base: Partial<WorksiteWithAccountsCount> = {}): WorksiteWithAccountsCount => ({
  id: base.id || faker.datatype.uuid(),
  createdAt: base.createdAt || faker.date.past().toISOString(),
  updatedAt: base.updatedAt || faker.date.past().toISOString(),
  name: base.name || `${faker.address.city()} ${faker.company.companySuffix()}`,
  enterpriseId: base.enterpriseId || faker.datatype.uuid(),
  defaultTimezone: base.defaultTimezone || fakeTimezone(),
  regionDescription: base.regionDescription ?? faker.address.state(),
  inboundTripThreshold: base.inboundTripThreshold ?? randomIn({
    min: 5,
    max: 30
  }),
  outboundTripThreshold: base.outboundTripThreshold ?? randomIn({
    min: 5,
    max: 30
  }),
  accountsCount: base.accountsCount ?? randomIn({
    min: 0,
    max: 500
  }),
  buildingsCount: base.buildingsCount ?? randomIn({
    min: 0,
    max: 20
  })
});

/**
 * Generate many fake worksites for testing lists
 * @param count Number of worksites to generate
 * @param base - Partial worksite properties to apply to all generated worksites
 */
export const generateManyWorksites = (count: number, base: Partial<WorksiteWithAccountsCount> = {}): WorksiteWithAccountsCount[] => Array.from({
  length: count
}, (_, i) => fakeWorksite({
  ...base,
  name: `Worksite ${i + 1} - ${faker.address.city()}`
}));